import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import ContractHistory from 'modules/contracts/components/ContractHistory'
import { Timeline } from 'modules/contracts/components/ContractHistory/Timeline'
import type Contract from 'modules/contracts/lib/Contract'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

interface Props {
  open: boolean
  selectedContractVersion: ContractVersion
  allContractVersionsSorted: ContractVersion[]
  contracts: Contract[]
  setSelectedContractVersion: (contractVersion: ContractVersion | undefined) => void
  toggleHistory: () => void
}

const style = { zIndex: '1' }

const History = ({
  open,
  selectedContractVersion,
  allContractVersionsSorted,
  contracts,
  setSelectedContractVersion,
  toggleHistory,
}: Props) => {
  return (
    <Sidepanel
      title={i18n.t('contract_versions.header.history')}
      open={open}
      onClose={() => toggleHistory()}
      closeLabel={i18n.t('common.close')}
      width="wide"
    >
      {contracts.map((contract, index) => {
        const previousContract = contracts[index + 1]
        return (
          <Box
            flexDirection="row"
            width="full"
            gap="s16"
            paddingX="s8"
            style={style}
            key={contract.formattedStartOn()}
            paddingBottom={previousContract ? 's48' : 's0'}
          >
            <Timeline isTerminated={contract.hasExpired()} />
            <Box flexGrow paddingTop="s16" width="full">
              <ContractHistory
                contract={contract}
                contractContractVersions={contract.sortedVersions('desc')}
                allContractVersionsSorted={allContractVersionsSorted}
                previousContract={previousContract}
                highlightedItem={selectedContractVersion}
                setSelectedContractVersion={setSelectedContractVersion}
              />
            </Box>
          </Box>
        )
      })}
    </Sidepanel>
  )
}

export default observer(History)
